/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Lot_Items_Split_BadgeInputs */

const vi_lot_items_split_badge = /** @type {(inputs: Lot_Items_Split_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tách ${i?.n} lô`)
};

/**

* @param {Lot_Items_Split_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_split_badge = /** @type {((inputs: Lot_Items_Split_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Split_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_split_badge(inputs)
});